import React from 'react';
import { IHeadingComponent } from '../df-form-preview-interfaces';

interface DfFormHeadingProps {
  id: string;
  properties: IHeadingComponent;
  mode?: 'edit' | 'preview' | 'test';
  className?: string;
  hideLabel?: boolean;
}

export const DfFormHeading: React.FC<DfFormHeadingProps> = ({
  id,
  properties,
  className = '',
  hideLabel = false
}) => {
  const level = (properties.styles as any)?.level ?? properties.basic.level ?? 1;
  const text = properties.basic.label;
  
  // Get heading classes
  const getHeadingClasses = (): string => {
    const base = 'form-heading';
    const levelClass = `h${level}`;
    const alignment = properties?.styles?.textAlign ? `text-${properties.styles.textAlign}` : '';
    return `${base} ${levelClass} ${alignment} ${className}`.trim();
  };

  // Get inline styles
  const getInlineStyles = (): React.CSSProperties => {
    const styles: React.CSSProperties = {};
    
    if (properties?.styles?.fontSize) {
      styles.fontSize = properties.styles.fontSize;
    }
    
    if (properties?.styles?.color) {
      styles.color = properties.styles.color;
    }
    
    return styles;
  };

  // Render the appropriate heading element
  const renderHeading = () => {
    const headingProps = {
      id,
      className: getHeadingClasses(),
      style: getInlineStyles(),
    };

    switch (level) {
      case 1:
        return <h1 {...headingProps}>{text}</h1>;
      case 2:
        return <h2 {...headingProps}>{text}</h2>;
      case 3:
        return <h3 {...headingProps}>{text}</h3>;
      case 4:
        return <h4 {...headingProps}>{text}</h4>;
      case 5:
        return <h5 {...headingProps}>{text}</h5>;
      case 6:
        return <h6 {...headingProps}>{text}</h6>;
      default:
        return <h1 {...headingProps}>{text}</h1>;
    }
  };

  // If hideLabel is true, don't render the heading
  if (hideLabel) {
    return null;
  }
  
  return renderHeading();
};

export default DfFormHeading;
